import { render, staticRenderFns } from "./KlippyStatusCard.vue?vue&type=template&id=544bc038&"
import script from "./KlippyStatusCard.vue?vue&type=script&lang=ts&"
export * from "./KlippyStatusCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports